import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import { Camera, ChevronRight } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { useAnnouncement, useAlbums } from '../lib/queries';

export default function Dashboard() {
  const { user } = useAuth();
  const { data: announcement, isLoading: announcementLoading } = useAnnouncement();
  const { data: albums } = useAlbums();
  const previewAlbums = albums?.slice(0, 6) ?? [];

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-serif text-primary mb-2">Välkommen, {user?.name}</h1>
      <p className="text-ink-muted mb-8">Stamlogen 2026 — W:6 175-årsjubileum</p>

      <section className="bg-white rounded-2xl p-6 md:p-8 shadow-sm mb-6">
        {announcementLoading ? (
          <p className="text-ink-muted">Laddar…</p>
        ) : announcement?.announcementHtml ? (
          <div
            className="prose prose-sm md:prose max-w-none"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(announcement.announcementHtml) }}
          />
        ) : (
          <p className="text-ink-muted">Inget meddelande än.</p>
        )}
      </section>

      {previewAlbums.length > 0 && (
        <section className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-serif">Senaste album</h2>
            <Link to="/foto" className="text-sm text-primary hover:underline flex items-center gap-1">
              Alla album <ChevronRight size={14} />
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {previewAlbums.map((album) => (
              <Link
                key={album.id}
                to={`/foto/${album.id}`}
                className="group relative block rounded-lg overflow-hidden bg-surface-cream aspect-square"
              >
                {album.coverThumbUrl ? (
                  <img
                    src={album.coverThumbUrl}
                    alt={album.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <Camera className="text-primary/30" size={32} />
                  </div>
                )}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                  <p className="text-white text-sm font-medium truncate">{album.name}</p>
                  <p className="text-white/70 text-xs">{album.photoCount} foton</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
